import { atomWithStorage } from "jotai/utils";
import { RecurringIncome } from "../types";

/**
 * Recurring income rules — "$2,400 every 2 weeks". The engine expands these into
 * dated events for trailing stats and the projection, so a regular-paycheck user
 * never has to log an individual payday. Persisted in localStorage until the
 * cash-flow API is wired.
 */
export const recurringIncomeAtom = atomWithStorage<RecurringIncome[]>(
  "cashflow.recurringIncome",
  [],
  undefined,
  { getOnInit: true },
);
